import React, { useState, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import TableComponent from "../../Common/TableComponent/tableComponent";
import { TableLoader } from "../../Common/ShimmerLoader";
const GVPNotClearence = () => {
  const headers = [
    "zone",
    "circle",
    "ward",
    "gvp_point_name",
    "no_of_days_not_cleared",
  ];
  const [isLoading, setIsLoading] = useState(false);

  const searchResults = require("../../Common/Json/gvpNotClearence.json");

  useEffect(() => {
    // Simulate loading data
    setIsLoading(true);

    // Assuming you have an asynchronous data fetching process
    fetchData()
      .then(() => setIsLoading(false)) // Once data fetching is done, set isLoading to false
      .catch((error) => {
        setIsLoading(false); // Set isLoading to false in case of error
        console.error("Error fetching data:", error);
        // Handle error (e.g., show error message)
      });
  }, []); // Empty dependency array means this effect runs only once on mount

  // Function to simulate asynchronous data fetching
  const fetchData = async () => {
    await new Promise((resolve) => setTimeout(resolve, 2000));
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              <h4 style={{ display: "flex", marginTop: "30px" }}>
                GVPs Not Clearance Report
              </h4>
            </div>
            <div class="row" style={{ textAlign: "justify" }}>
              <div class="col-md-3 mb-3">
                <label htmlFor="fromDate">From Date:</label>
                <input
                  type="datetime-local"
                  id="fromDate"
                  className="form-control"
                  // value={`${fromDate}T${fromTime}`}
                  // onChange={(e) => handleDateTimeChange(e, true)}
                />
              </div>

              <div class="col-md-3 mb-3">
                <label htmlFor="toDate">To Date:</label>

                <input
                  type="datetime-local"
                  id="toDate"
                  className="form-control"
                  // value={`${toDate}T${toTime}`}
                  // onChange={(e) => handleDateTimeChange(e, false)}
                />
              </div>
              <div class="col-md-3" style={{ marginTop: "27px" }}>
                <button
                  type="submit"
                  value="submit"
                  // onClick={handleSearch}
                  className="btn btn-danger"
                  style={{ backgroundColor: "rgb(236, 17, 23)" }}
                >
                  {/* <SearchOutlinedIcon /> */}
                  Search
                </button>
              </div>
            </div>
            <div className="card">
              <div className="card-body">
                <TableComponent isLoading={isLoading}
                  DataFetchURL={searchResults}
                  headers={headers}
                  filterFunction={(data) =>
                    data.filter(
                      (item) => item.status === 1 || item.status === 2
                    )
                  }
                  // editData={handleEditShift} // Pass the callback function
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GVPNotClearence;
